var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23589",
    "data-name": "Group 23589",
    transform: "translate(-66 -2078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23561",
    "data-name": "Group 23561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INC_Cloud_1",
    transform: "translate(-1021 417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    transform: "translate(1087 1661)",
    fill: "#fff",
    stroke: "#0050ad",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 104.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 97,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49986",
    "data-name": "Path 49986",
    d: "M-6240.577-104.6l-52.09,24.6s-1.1-13.266-5.057-13.953S-6240.577-104.6-6240.577-104.6Z",
    transform: "translate(6455.177 2365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "UBR",
    transform: "translate(124 2121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21194",
    "data-name": "Group 21194",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36024",
    "data-name": "Path 36024",
    d: "M238.526,0c3.54,2.4,5.8,5.873,7.748,9.532a35.28,35.28,0,0,1-5.932,41.138,3.538,3.538,0,0,1-3.579,1.223,3.284,3.284,0,0,1-2.5-2.531,3.672,3.672,0,0,1,1.261-3.577A26.791,26.791,0,0,0,242.2,34.448q4.437-15.563-6.267-27.777c-.08-.091-.165-.177-.248-.265-2.407-2.57-2-4.858,1.141-6.406Z",
    transform: "translate(-159.535)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36025",
    "data-name": "Path 36025",
    d: "M72.689,133.045c-1.7-4.826-3.382-9.554-5.025-14.295a1,1,0,0,0-1.142-.761q-20.182.018-40.365.034a1.389,1.389,0,0,0-1.092.582c-1.739,4.784-3.414,9.591-5.117,14.429.888.361-3.508,3.322-2.747,3.66,1.784.794-.064-.431,0,1.531.059,1.817-.475,2.43-.8,4.213-.463,2.541,2.595-.624,0-.558-5.062.129,2.261-3.5-2.8-3.655-2.954-.088-1.387,5.591-1.8,2.269-.176-1.411-2.321,1.427-2.254,0,.093-1.992-3.1-1.433-1.346-2.269,2.058-.98-.908-5.547,1.346-5.6.635-.016,1.09-.117,1.333-.872,6.389-19.845,14.392-39.087,21.938-58.5,1.3-3.341,2.572-6.692,3.889-10.025a1.3,1.3,0,0,0-.3-1.66A14.1,14.1,0,0,1,47.541,37.435,13.4,13.4,0,0,1,59.48,46.428c2.1,5.481.991,10.515-2.974,14.843a1.82,1.82,0,0,0-.478,2.246q10.218,26.282,20.33,52.6c1.918,5.019,3.551,10.149,5.254,15.247a1.694,1.694,0,0,0,1.654,1.309c2.109.32-3.675-.292-1.654.368,1.886.616-1.845,1.609-1.812,3.65.028,1.741,3.748-.228,3.466,1.483-.424,2.571-.049-.069-2.666,0-5.1.135,2.1.224-3,.048-3.062-.106-1.824,2.167-2.2-1.531-.124-1.223-1.093,1.228-1,0,.152-2.014-5.918-1.9-4.089-2.7.727-.318,1.474-.59,2.378-.948m-12.11-21.79L46.314,98.019l-14.25,13.236Zm-14.26-22.39c2.337-2.169,4.569-4.218,6.759-6.311a1.141,1.141,0,0,0,.179-1Q50.341,73.908,47.328,66.3a1.386,1.386,0,0,0-1.042-.61,1.19,1.19,0,0,0-.962.544Q42.284,73.9,39.353,81.6a1.029,1.029,0,0,0,.161.907c2.218,2.115,4.472,4.192,6.806,6.362M31,102.8l.169.115L41.39,93.432l-4.929-4.556L31,102.8m30.459.11.168-.106L56.165,88.877l-4.915,4.562,10.213,9.471",
    transform: "translate(0 -25.296)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36026",
    "data-name": "Path 36026",
    d: "M5.52,27.656A34.932,34.932,0,0,1,15.582,3.531c1.561-1.617,3.586-1.791,5.044-.452,1.508,1.385,1.5,3.463-.086,5.139a28.09,28.09,0,0,0-8.01,22.494,27.535,27.535,0,0,0,7.608,16.973c1,1.067,1.874,2.162,1.537,3.73a3.288,3.288,0,0,1-2.407,2.616,3.334,3.334,0,0,1-3.517-1.013A34.77,34.77,0,0,1,8.76,42.938,36.574,36.574,0,0,1,5.52,27.656",
    transform: "translate(-3.736 -1.479)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36027",
    "data-name": "Path 36027",
    d: "M213.275,43.019c-.162,6.921-2.354,12.351-6.744,16.867a3.424,3.424,0,0,1-5.916-1.619,3.614,3.614,0,0,1,1.226-3.363A15.846,15.846,0,0,0,206.1,46.52a16.243,16.243,0,0,0-4.246-14.393,3.734,3.734,0,0,1-1.257-3.357,3.254,3.254,0,0,1,2.373-2.654,3.385,3.385,0,0,1,3.547.968,22.924,22.924,0,0,1,6.341,12.256c.25,1.423.327,2.877.414,3.678",
    transform: "translate(-136.582 -17.573)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36028",
    "data-name": "Path 36028",
    d: "M59.163,27.365a4.154,4.154,0,0,1,3.17,1.964,3.209,3.209,0,0,1-.04,3.441,5.819,5.819,0,0,1-.755.94,16.479,16.479,0,0,0,0,22.861,3.692,3.692,0,0,1,1.215,3.259A3.423,3.423,0,0,1,56.879,61.6a22.318,22.318,0,0,1-6.257-11.64,22.841,22.841,0,0,1,6.087-21.044,11.629,11.629,0,0,1,2.455-1.554",
    transform: "translate(-34.135 -18.523)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_944",
    "data-name": "Ellipse 944",
    transform: "translate(38 18)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18614",
    "data-name": "Rectangle 18614",
    width: 21,
    height: 13,
    rx: 6.5,
    transform: "translate(5 106)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18615",
    "data-name": "Rectangle 18615",
    width: 15,
    height: 7,
    rx: 3.5,
    transform: "translate(8 109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18616",
    "data-name": "Rectangle 18616",
    width: 21,
    height: 13,
    rx: 6.5,
    transform: "translate(67 106)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18617",
    "data-name": "Rectangle 18617",
    width: 15,
    height: 7,
    rx: 3.5,
    transform: "translate(70 109)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49987",
    "data-name": "Path 49987",
    d: "M-6857.828,51.656l3.141,2.969,4.266-3.953Z",
    transform: "translate(7025 2132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49988",
    "data-name": "Path 49988",
    d: "M-6870.937,63.766l-2.906,7.625,6.328-5.875Z",
    transform: "translate(7025 2133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49989",
    "data-name": "Path 49989",
    d: "M-6870.094,64.625l2.578,6.766-6.328-5.875Z",
    transform: "translate(7057 2133)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbr);
export default __webpack_public_path__ + "static/media/ubr.7eb862e12efed0bc3e1a2b8140fc1701.svg";
export { ForwardRef as ReactComponent };